import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { decryptToken } from "../utils/getToken";

const AllCommentsPage = () => {
  const { blogId } = useParams();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const url = API_BASE_URL
  const token = decryptToken("accessToken") || ""
  console.log(blogId)
  useEffect(() => {
    const fetchComments = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${url}/blog-comment/${blogId}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await res.json();

        if (!Array.isArray(data.data)) {
          throw new Error("Invalid response format");
        }

        setComments(data.data);
      } catch (err) {
        console.error("❌ Error fetching all comments:", err);
        setError("Failed to load comments.");
      } finally {
        setLoading(false);
      }
    };

    if (blogId) fetchComments();
  }, [blogId]);

  return (
    <div className="min-h-screen bg-white text-black px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <h2 className="flex items-center text-xl font-semibold text-[#4e59c2] mb-4">
          <MessageCircle size={20} className="mr-2 text-[#6274cf]" />
          All Comments <span className="ml-2 text-gray-700">({comments.length})</span>
        </h2>

        {loading && (
          <p className="text-[#6274cf] animate-pulse">Loading comments...</p>
        )}
        {error && (
          <p className="text-red-500 font-medium">{error}</p>
        )}

        <ul className="space-y-4">
          {comments.map((comment, index) => (
            <li
              key={index}
              className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition"
            >
              <div className="flex justify-between items-center mb-1">
                <strong className="text-[#4e59c2]">
                  {comment.author || "Anonymous"}
                </strong>
                <span className="text-xs text-gray-500">
                  {new Date(comment.createdAt).toLocaleString()}
                </span>
              </div>
              <p className="text-gray-800">{comment.message}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AllCommentsPage;
